import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// We need this file in embeddable contexts where the main app's i18n provider isn't available.
// And Embeddable do not have access to our alias in tsconfig. That's why we use a relative path to the store.
import { useLocaleStore } from '../stores/locale';

i18next
  .use(Backend) // for dynamic loading of translation
  .use(initReactI18next)
  .init({
    lng: useLocaleStore.getState().lang, // Get initial language from store, not reactive for changes
    fallbackLng: 'en',
    returnEmptyString: false,
    debug: true,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export { i18next as i18n };
